import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import FuturaIcon from "../components/FuturaIcon";
import { useLanguage } from "../i18n/LanguageContext";
import { LanguageSelector } from "../components/LanguageSelector";
import LegalFooter from "../components/LegalFooter";

const CookiePolicy = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-[#F5F5F7] flex flex-col" data-testid="cookie-policy-page">
      <header className="bg-white border-b border-[#E5E5EA] sticky top-0 z-20">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-[#6B7280] hover:text-[#111111] transition-colors">
            <ArrowLeft className="w-5 h-5" /><span className="font-medium">{t("nav_back")}</span>
          </Link>
          <div className="flex items-center gap-3">
            <LanguageSelector />
            <div className="w-8 h-8 rounded-xl bg-gradient-to-br from-[#002FA7] to-[#5B21B6] flex items-center justify-center p-1">
              <FuturaIcon className="w-full h-full text-white" />
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-12 flex-1">
        <h1 className="font-['Outfit'] text-3xl font-semibold text-[#111111] mb-2">{t("cookiep_title")}</h1>
        <p className="text-[#6B7280] text-sm mb-10">{t("cookiep_updated")}</p>

        <div className="space-y-6">
          <Section title={t("cookiep_what_title")} text={t("cookiep_what_text")} />
          <Section title={t("cookiep_types_title")} text={t("cookiep_types_text")} />
          <Section title={t("cookiep_essential_title")} text={t("cookiep_essential_text")} />
          <Section title={t("cookiep_analytics_title")} text={t("cookiep_analytics_text")} />
          <Section title={t("cookiep_manage_title")} text={t("cookiep_manage_text")} />
          <Section title={t("cookiep_revoke_title")} text={t("cookiep_revoke_text")} />
          <Section title={t("cookiep_changes_title")} text={t("cookiep_changes_text")} />
        </div>
      </main>

      <LegalFooter />
    </div>
  );
};

const Section = ({ title, text }) => (
  <div className="bg-white rounded-2xl p-6 border border-[#E5E5EA]">
    <h2 className="font-['Outfit'] text-lg font-semibold text-[#111111] mb-3">{title}</h2>
    <p className="text-[#6B7280] leading-relaxed text-sm whitespace-pre-line">{text}</p>
  </div>
);

export default CookiePolicy;
